module.exports = __webpack_public_path__ + "media/Video 24.286a2fd9.mp4";